import React from 'react';
import '../../styles/republic-day.css';

/**
 * Republic Day Header Decorations component - adds tricolor elements to header
 * Displays Ashoka Chakra, decorative elements, and tricolor accents
 */
const TricolorDecorations = () => {
  return (
    <div className="republic-day-header-decorations" aria-hidden="true">
      {/* Ashoka Chakra at left */}
      <div className="decoration-chakra">
        <span className="chakra-icon">☸</span>
      </div>
      
      {/* Tricolor stripes decoration */}
      <div className="decoration-tricolor-stripes">
        <div className="stripe saffron"></div>
        <div className="stripe white"></div>
        <div className="stripe green"></div>
      </div>
      
      {/* Tricolor dots/accents */}
      <div className="decoration-dots">
        <span className="dot dot-saffron" style={{ left: '10%' }}>●</span>
        <span className="dot dot-white" style={{ left: '20%' }}>●</span>
        <span className="dot dot-green" style={{ left: '30%' }}>●</span>
        <span className="dot dot-saffron" style={{ left: '50%' }}>●</span>
        <span className="dot dot-white" style={{ left: '60%' }}>●</span>
        <span className="dot dot-green" style={{ left: '70%' }}>●</span>
        <span className="dot dot-saffron" style={{ left: '80%' }}>●</span>
        <span className="dot dot-white" style={{ left: '90%' }}>●</span>
      </div>
    </div>
  );
};

export default TricolorDecorations;
